import i from "react";
import { useTheme as M, Text as _ } from "@chakra-ui/react";
import { MdAutoAwesome as k, MdOutlineCameraAlt as A } from "react-icons/md";
import "./button.js";
import { IconButton as B } from "./icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "./masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "./close-button.js";
function j({
  type: c,
  data: a,
  multiFunctionButtonText: o,
  handleMultiFunctionButtonClick: l,
  topPosition: m,
  leftPosition: u
}) {
  const t = c === "EXPLORE_MORE", {
    element: { spacingSmall: p },
    iconButtonLargeIconSizeMobile: e,
    iconButtonLargeSize: n,
    icon: { accent3: s, onInteractive: d },
    text: { accent3: b, onInteractive: f },
    background: { accent3: g, dark: v, accent3SubduedPressed: x, darkPressed: h },
    iconButtonDefaultText: E,
    elevation: { low: I }
  } = M(), r = t ? x : h;
  return /* @__PURE__ */ i.createElement(
    B,
    {
      role: "button",
      "aria-label": o,
      layout: "vertical",
      icon: t ? k : A,
      iconFill: t ? s : f,
      iconWidth: e,
      iconHeight: e,
      pos: "absolute",
      top: m || "0",
      left: u || "0",
      flexDir: "column",
      w: n,
      h: n,
      p,
      bg: t ? g : v,
      color: t ? b : d,
      isRounded: !0,
      _hover: { shadow: I },
      _active: { bg: r },
      _focus: { bg: r },
      onClick: () => l(a)
    },
    /* @__PURE__ */ i.createElement(_, { sx: { ...E } }, o)
  );
}
export {
  j as MultiFunctionButton
};
